import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '../modal';
import Button from '../button';
import styles from './delete.module.scss';

const DeleteConfirmation = ({ isActive, onClose, confirmDelete, isDoument, cancelRequest, comment, handleAnswerChanged }) => {
  const [key, setKey] = useState('DELETE');
  const [deleteFlag, setDeleteFlag] = useState('');
  const [enableDeleteBtn, setEnableDeleteFlag] = useState(false);


  useEffect(() => {
    if (deleteFlag === '') {
      setEnableDeleteFlag(false);
    }
  }, [deleteFlag]);

  const handleInputChange = (value) => {
    setDeleteFlag(value);
    setKey('DELETE');
    setEnableDeleteFlag(false);
  };

  if (deleteFlag === key) {
    setEnableDeleteFlag(true);
    setKey('');
  }

  const handleConfirmDelete = () => {
    confirmDelete();
    setEnableDeleteFlag(false);
  };

  const handleClose = () => {
    setEnableDeleteFlag(false);
    onClose();
  };

  return (
    <Modal
      width={cancelRequest ? '500px' : '400px'}
      minHeight="150px"
      showIn={isActive}
      contentStyles={{
        padding: '15px 30px 5px 40px'
      }}
      centered
      onClose={handleClose}
    >
      <div className={styles.confirmDelete}>
        <div className={styles.header}>
          {
            isDoument
              ? (
                <FormattedMessage
                  tagName="p"
                  id="documents.delete.confirmation.title"
                  defaultMessage="Deleting this folder will also delete all the files inside this folder, Are you sure?"
                />
              )
              : (
                <FormattedMessage
                  tagName="p"
                  id="general.delete.header"
                  defaultMessage="Are you absolutely sure ?"
                />
              )
          }
          <button className={styles.closeIcon} onClick={handleClose}>&times;</button>
        </div>
        {!cancelRequest
        && <div className={styles.confirmDeleteBody}>
          <FormattedMessage
            tagName="p"
            id="general.delete.confirm"
            defaultMessage="Please type DELETE to confirm deletion"
          />
          <input type="text" className={styles.inputField} onChange={e => handleInputChange(e.target.value)} />
           </div>
        }
        {cancelRequest
        && <div className={styles.confirmDeleteBody}>
          <FormattedMessage
            tagName="p"
            id="general.delete.confirm"
            defaultMessage="Please comment your reason to Cancel the Request"
          />
          <textarea type="text" rows={5} cols={50}
           className={styles.inputField} onChange={(e) => { handleAnswerChanged(e.target.value); setEnableDeleteFlag(true); }} />
           </div>
        }
        {!cancelRequest
        && <div className={styles.footer}>
          <Button
            action="red"
            translationID="general.button.confirm_delete"
            defaultText="Confirm Delete"
            onClick={handleConfirmDelete}
            disabled={!enableDeleteBtn}
          />
           </div>
        }
        {cancelRequest
        && <div className={styles.footer}>
          <Button
            action="red"
            translationID="general.button.cancelRequest"
            defaultText="Cancel Request"
            onClick={handleConfirmDelete}
            disabled={!enableDeleteBtn || comment === ''}
          />
           </div>}
      </div>
    </Modal>
  );
};
export default DeleteConfirmation;
